import React, {Component} from 'react'
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import {initNavbarState} from 'actions/navbar.js';
import DatabaseService from 'services/DatabaseService.js';
import Invitations from './Invitations.js';

class InvitationsContainer extends Component {
    constructor(props){
        super(props);
        this.limit = 20;
        this.busy = false;
        this.start = 0;
        this.endReached = false;
        this.employees = [];
        this.state = {employees:this.employees, invitationPoints:0, busy:this.busy, start:this.start, endReached:this.endReached};
        this.onClickInvite = this.onClickInvite.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.setScrollContainer = this.setScrollContainer.bind(this);
    }
    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode:'main', menuEnable:true, backButtonEnable:false, rewardsEnable:true, title:this.props.t("Invite Friends")}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.nextPage();
    }

    onScroll(event) {
        this.loadPageIfEndVisible();
    }

    setScrollContainer(el) {
        this.scrollContainer = el;
    }

    loadPageIfEndVisible() {
        if(this.scrollContainer) {
            var scrollTop =    this.scrollContainer.scrollTop;
            var scrollHeight = this.scrollContainer.scrollHeight;
            var clientHeight = this.scrollContainer.clientHeight;
            var lastPageInView = (scrollTop >= scrollHeight - 1.5*clientHeight);
            if(lastPageInView) {
                this.nextPage();
            }
        }
    }


    nextPage() {
        if(!this.busy && !this.endReached) {
            console.log('nextPage');
            this.busy = true;
            this.setState({busy:this.busy});
            DatabaseService.fetchInvitations({start:this.start, limit:this.limit})
                .then((result)=>{
                    var employees = result.employees;
                    this.endReached = employees.length < this.limit;
                    this.start = this.start + this.limit;
                    this.employees = this.employees.concat(employees);
                    this.setState({employees:this.employees, 
                                   invitationPoints:result.invitationPoints, 
                                   endReached:this.endReached,   
                                   start:this.start});
                })
                .catch((error)=>{
                    console.error('ERROR:');
                    console.error(error);
                })
                .then(()=>{
                    this.busy = false;
                    this.setState({busy:this.busy});
                });
        }
    }

    updateEmployee(id, companyEmployeeInvitation) {
        this.employees = this.employees.map(e=>(e.id==id ? {...e, companyEmployeeInvitation:companyEmployeeInvitation} : e));
        this.setState({employees:this.employees});
    }

    onClickInvite(event) {
        var companyEmployeeId = event.currentTarget.getAttribute('data-id');
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        DatabaseService.inviteFriend(companyEmployeeId)
            .then((result)=>{
                console.log('inviteFriend: ', result);
                var companyEmployeeInvitation = result.companyEmployeeInvitation;
                this.updateEmployee(companyEmployeeId, companyEmployeeInvitation);
            })
            .catch((error)=>{
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    render() {
        return (
                <Invitations 
                    setScrollContainer={this.setScrollContainer}
                    onScroll={this.onScroll}
                    endReached={this.state.endReached}
                    busy={this.state.busy}
                    employees={this.state.employees}
                    invitationPoints={this.state.invitationPoints}
                    onClickInvite={this.onClickInvite} />
            );
    }
}

export default connect()(translate('invitations')(InvitationsContainer));



// WEBPACK FOOTER //
// ./src/modules/invitations/InvitationsContainer.js